/**
 * The relay work-item states, in the order the server declares them.
 *
 * MIRRORS `backend/models/agent.py`'s `ALL_WORK_STATES`, which is itself derived
 * (`OPEN_WORK_STATES + TERMINAL_WORK_STATES`) so a new state cannot be added there
 * without landing in a bucket. This copy exists because the fleet payload returns the
 * counts as a MAP keyed by state, and a page that rendered `Object.entries` of it would
 * print whatever arrived in whatever order — including nothing at all for a state with no
 * items, which is precisely the reading an operator needs ("0 queued").
 *
 * IT IS A RENDERING ORDER, NOT A SECOND SOURCE OF TRUTH. The server sends every state
 * with its zero, so a state missing from this list simply is not displayed, and a state
 * listed here that the server stops sending renders 0 — neither fabricates a count. The
 * states are not read back to the server, and nothing branches on them.
 */
export const ALL_WORK_STATES = [
  'pending',
  'leased',
  'relayed',
  'refused',
  'abandoned',
] as const

export type WorkState = (typeof ALL_WORK_STATES)[number]
